import { createFileRoute, redirect } from "@tanstack/react-router";
import {
  getOnboardingV1RecoveryStep,
  normalizeOnboardingV1StepSearch,
  parseOnboardingV1StepId,
  readOnboardingV1Draft,
  resolveOnboardingV1DraftStep,
} from "~/features/start/onboarding-v1-step-navigation";
import { m } from "~/lib/i18n";
import { startStylesheet } from "~/features/start/start-styles";

export const Route = createFileRoute("/start")({
  validateSearch: normalizeOnboardingV1StepSearch,
  // Draft recovery is browser-owned. Deep links (including invalid step values)
  // keep their existing client guard; only the step-less frame, which the
  // username dialog opens over, is SSR.
  ssr: ({ location }) => !new URLSearchParams(location.searchStr).has("step"),
  beforeLoad: ({ location }) => {
    const rawStep = new URLSearchParams(location.searchStr).get("step");
    if (rawStep === null) {
      return;
    }

    const requestedStep = parseOnboardingV1StepId(rawStep);
    const draft = readOnboardingV1Draft();
    if (requestedStep === "fund" && draft === null) {
      return;
    }

    const recoveryStep =
      requestedStep === null
        ? getOnboardingV1RecoveryStep(draft)
        : resolveOnboardingV1DraftStep(requestedStep, draft);
    // The username is chosen on step-less `/start`, so a legacy
    // `?step=name` or `?step=hook` link lands there.
    if (requestedStep === recoveryStep && recoveryStep !== "name") {
      return;
    }

    throw redirect({
      replace: true,
      search: normalizeOnboardingV1StepSearch({ step: recoveryStep }),
      to: "/start",
    });
  },
  head: () => ({
    links: [{ rel: "stylesheet", href: startStylesheet, id: "start-styles" }],
    meta: [
      { title: m.start_page_meta_title() },
      { content: m.start_page_meta_description(), name: "description" },
      { content: "noindex, nofollow", name: "robots" },
    ],
  }),
});
